import { getMetadataFromUrl, urls } from "../../data";
import __styles from "./style.module.scss";
static const { badge, component, tabs, pagination } = __styles;
export interface Input {
  content?: Marko.Body;
}
<const/{
  dsComponent,
  metadata,
  currentTab,
  page,
  componentUrls,
  a11yPage,
  cssPage,
  jsPage,
  next,
  prev,
}=getMetadataFromUrl($global.url.pathname)>

<const/badgeClass=[badge]>

<if=metadata && page === "components">
  <const/getAriaCurrentValue(tabName: string) {
    return currentTab === tabName ? "page" : undefined;
  }>

  <div class=component>
    <div class=["navigation-tabs", "navigation-tabs--large", tabs]>
      <ul
        class="navigation-tabs__items"
        aria-label="Component implementation tabs"
      >
        <li class="navigation-tabs__item">
          <a
            href=componentUrls?.overview
            aria-current=getAriaCurrentValue("overview")
          >
            Overview
          </a>
        </li>
        <if=a11yPage>
          <li class="navigation-tabs__item">
            <a
              href=componentUrls?.accessibility
              aria-current=getAriaCurrentValue("accessibility")
            >
              Accessibility
            </a>
          </li>
        </if>
        <if=cssPage>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.css aria-current=getAriaCurrentValue("css")>
              CSS${" "}
              <if=dsComponent?.version>
                <span
                  class=badgeClass
                  role="img"
                  aria-label=`Static version ${dsComponent?.version || ""}`
                >
                  ${dsComponent?.version || ""}
                </span>
              </if>
            </a>
          </li>
        </if>
        <if=jsPage>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.js aria-current=getAriaCurrentValue("js")>
              Javascript${" "}
            </a>
          </li>
        </if>

        <if=componentUrls?.cssStorybook>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.cssStorybook target="_blank">
              CSS Storybook${" "}
              <svg
                class="icon icon--16"
                height="16"
                width="16"
                aria-hidden="true"
              >
                <use href="#icon-external-link-16"/>
              </svg>
            </a>
          </li>
        </if>
        <if=componentUrls?.marko>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.marko target="_blank">
              Marko Storybook
              <span
                class=badgeClass
                role="img"
                aria-label=`Marko version ${dsComponent?.markoVersion || ""}`
              >
                ${dsComponent?.markoVersion || ""}
              </span>
              <svg
                class="icon icon--16"
                height="16"
                width="16"
                aria-hidden="true"
              >
                <use href="#icon-external-link-16"/>
              </svg>
            </a>
          </li>
        </if>
        <if=componentUrls?.react>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.react target="_blank">
              React Storybook
              <span
                class=badgeClass
                role="img"
                aria-label=`React version ${dsComponent?.reactVersion || ""}`
              >
                ${dsComponent?.reactVersion || ""}
              </span>
              <svg
                class="icon icon--16"
                height="16"
                width="16"
                aria-hidden="true"
              >
                <use href="#icon-external-link-16"/>
              </svg>
            </a>
          </li>
        </if>
        <if=componentUrls?.dsUrl>
          <li class="navigation-tabs__item">
            <a href=componentUrls?.dsUrl target="_blank">
              Design System${" "}
              <svg
                class="icon icon--16"
                height="16"
                width="16"
                aria-hidden="true"
              >
                <use href="#icon-external-link-16"/>
              </svg>
            </a>
          </li>
        </if>
      </ul>
      <div class="navigation-tabs__content" role="tabpanel">
        <div class="navigation-tabs__cell">
          <${input.content}/>
        </div>
      </div>
    </div>
    <div class=pagination>
      <if=prev>
        <a href=prev.componentUrls.overview>
          <svg class="icon icon--12">
            <use href="#icon-arrow-left-12"/>
          </svg>
          ${prev.properName} Component
        </a>
      </if>
      <else>
        <!-- Extra empty element -->
        <span/>
      </else>
      <if=next>
        <a href=next.componentUrls.overview>
          <span>${next.properName} Component</span>
          <svg class="icon icon--12">
            <use href="#icon-arrow-right-12"/>
          </svg>
        </a>
      </if>
    </div>
  </div>
</if>
<else>
  <${input.content}/>
</else>
